import { Platform } from '@/data/models/platform.interface';

export const toPlatforms = (platformsData: string[]): Platform[] => {
  return platformsData.map((platformName) => ({
    label: platformName,
    value: platformName,
  }));
};

export const toPlatform = (platformName: string): Platform => {
  return {
    label: platformName,
    value: platformName,
  };
};
